export const actionTypes = {
  REQUEST_START: 'TAPS.CERTIFICATE.REQUEST_START',
  REQUEST_SUCCESS: 'TAPS.CERTIFICATE.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'TAPS.CERTIFICATE.REQUEST_FAILURE',
  RESET_CERTIFICATE_INFO: 'TAPS.CERTIFICATE.RESET',
};

export function startRequest() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}

export function reset() {
  return {
    type: actionTypes.RESET_CERTIFICATE_INFO,
  };
}
